var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNugoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.334,
    height: 27.296,
    viewBox: "0 0 33.334 27.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#c);}.c{fill:url(#d);}.d{fill:url(#e);}.e{fill:url(#f);}.f{fill:url(#g);}.g{fill:#fff;}.h{fill:url(#i);}.i{fill:url(#j);}.j{fill:url(#k);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.004,
    y1: 0.5,
    x2: 0.015,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b0146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#2e58a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#4fa0ca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.532,
    y1: 0.03,
    x2: 0.44,
    y2: 0.995,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b0146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#2e58a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#4fa0ca",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.199,
    y1: 0.106,
    x2: 0.91,
    y2: 0.762,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.08,
    y1: 0.279,
    x2: 0.942,
    y2: 0.909,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 8553.934,
    y1: 14647.361,
    x2: 8552.979,
    y2: 14647.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d2339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#388e86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#5cbda3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.286,
    y1: -14.968,
    x2: 1.404,
    y2: -14.968,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 1.002,
    y1: 0.558,
    x2: 0.002,
    y2: 0.558,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.404,
    y1: -0.067,
    x2: 0.701,
    y2: 1.962,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-930.2 -6697.516)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M935.516,1023.579a10.81,10.81,0,0,0,3.8-.7,13.861,13.861,0,0,1-6.537,7.832,13.569,13.569,0,0,1-1.6.747l.008-.189-.016.188a5.908,5.908,0,0,1-7.138-2.748,5.666,5.666,0,0,1-.286-.6l.5-.211.146-.061c0,.006,0,.012.008.019.022.048.042.1.065.146s.051.109.079.163c.009.017.019.034.028.053s.02.037.03.054a4.819,4.819,0,0,0,.261.425c.062.09.127.177.2.262a4.837,4.837,0,0,0,.321.363,4.746,4.746,0,0,0,5.656.838c.067-.036.13-.075.194-.114l0-.006.036-.979a.1.1,0,0,0,.02-.017.053.053,0,0,0,.016-.01c.034-.028.067-.057.1-.085.081-.068.158-.138.234-.211.033-.028.064-.057.093-.087.053-.051.106-.1.155-.155s.1-.106.149-.16c.067-.071.129-.146.191-.22.031-.037.061-.074.092-.113.121-.152.233-.309.342-.469l.02-.032c.02-.031.039-.064.059-.095.011-.015.02-.033.03-.048s.019-.032.029-.048c.026-.043.051-.085.076-.129s.05-.085.073-.131a6.651,6.651,0,0,0,.374-.816c.031-.079.059-.16.087-.239.016-.045.029-.09.045-.135.006-.02.012-.039.017-.059l.023-.079c.04-.138.076-.273.107-.415,0-.023.009-.047.016-.07s.011-.046.016-.07c.019-.09.034-.177.048-.267a6.663,6.663,0,0,0,.084-1.056c0-.093,0-.186-.006-.28,0-.047-.006-.095-.008-.141a10.943,10.943,0,0,0,1.737.147Z",
    transform: "translate(18.054 5693.018)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M830.377,846.944a13.218,13.218,0,0,1-4.457-.036.317.317,0,0,1-.036-.008,9.821,9.821,0,0,1-3.726-1.5h0l-.061-.056c-.037-.034-.074-.068-.113-.1s-.071-.064-.109-.093a1.29,1.29,0,0,0-.1-.087l-.016-.011c-.071-.059-.146-.115-.219-.169,0,0,0,0,0,0s0,0,0,0,0,0,0,0c-.037-.028-.076-.056-.113-.081l-.079-.054c-.047-.033-.093-.064-.143-.095-.112-.075-.227-.144-.343-.208-.076-.045-.155-.087-.234-.126l-.118-.059-.121-.057c-.031-.016-.063-.03-.095-.043s-.034-.014-.051-.022c-.112-.05-.224-.093-.337-.136l-.137-.05-.121-.04c-.042-.014-.084-.028-.127-.04-.084-.026-.169-.051-.255-.071-.042-.012-.084-.023-.127-.034l-.115-.026-.188-.039-.172-.031c-.073-.012-.144-.022-.217-.033l-.194-.023c-.158-.017-.318-.026-.478-.033-.07,0-.14,0-.21,0h-.04q-.1,0-.2,0l-.177.008c-.059,0-.118.008-.178.014l-.028,0c-.056,0-.112.011-.168.017l-.047.006-.151.02c-.03,0-.059.009-.089.016-.048.006-.1.016-.144.025-.067.011-.135.025-.2.04-.134.029-.267.064-.4.1a.048.048,0,0,0-.014,0l-.172.053c-.071.023-.143.047-.213.071-.124.043-.247.092-.37.144l-.219.1-.123.059c-.031.016-.062.031-.093.048-.056.028-.11.057-.166.087a6.687,6.687,0,0,0-3.482,5.9s0,.43.009,1.13a10.378,10.378,0,0,1-.736,3.147,5.236,5.236,0,0,1-1.327,1.9,13.946,13.946,0,0,1-4.457-4.9q-.177-.326-.335-.657a13.951,13.951,0,0,1,.272-12.625q.244-.459.523-.9a13.958,13.958,0,0,1,25.56,9.562Z",
    transform: "translate(127.556 5866.584)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M823.568,888.725l-2.234,2.288c-.047-.033-.094-.064-.143-.1-.113-.073-.227-.143-.344-.207-.076-.045-.155-.087-.234-.126l-.119-.059c-.041-.02-.08-.039-.121-.057l-.094-.043-.051-.022c-.111-.049-.224-.093-.337-.136l-.137-.049-.121-.041-.127-.041c-.084-.026-.169-.051-.255-.072l-.129-.033L819.01,890l-.188-.039-.173-.031-.218-.033c-.064-.009-.129-.017-.193-.022-.159-.017-.319-.028-.479-.033-.07,0-.14,0-.21,0a6.627,6.627,0,0,0-1.843.258,6.7,6.7,0,0,0-4.836,6.464h0s0,.43.009,1.131a10.365,10.365,0,0,1-.736,3.147,5.228,5.228,0,0,1-1.326,1.9,13.934,13.934,0,0,1-4.457-4.9c-.118-.216-.231-.436-.336-.656a13.953,13.953,0,0,1,.271-12.625C805.276,883.879,815.19,877.424,823.568,888.725Z",
    transform: "translate(127.554 5820.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M830.113,922.209s-.586,1.746-1.4,4.149a6.7,6.7,0,0,0-4.836,6.464h0s0,.43.009,1.131a10.362,10.362,0,0,1-.736,3.147,5.227,5.227,0,0,1-1.326,1.9,13.934,13.934,0,0,1-4.457-4.9c-.118-.216-.231-.436-.336-.656C817.093,932.481,818.048,922.209,830.113,922.209Z",
    transform: "translate(114.548 5784.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M930.512,1033.036c.022.048.042.1.065.146s.051.109.079.163c.009.017.019.034.028.053s.019.037.028.054a4.881,4.881,0,0,0,.262.425c.062.09.127.177.2.262a4.737,4.737,0,0,0,5.977,1.2c.067-.036.13-.075.194-.113l.008.028,0-.042a9,9,0,0,0,4.248-6.461,10.929,10.929,0,0,1-1.737-.147c0,.047,0,.095.008.141,0,.093.006.186.006.28a6.631,6.631,0,0,1-.085,1.056c-.012.09-.029.178-.048.267l-.014.07c-.006.023-.011.047-.016.07-.031.141-.067.276-.107.415l-.023.079c-.006.019-.013.039-.019.059-.014.045-.028.09-.043.135-.028.079-.056.16-.087.239a6.663,6.663,0,0,1-.374.817c-.023.045-.048.089-.073.131s-.051.085-.078.129l-.028.048c-.009.016-.019.033-.03.048-.02.031-.039.063-.059.095l-.02.032c-.109.16-.22.317-.342.469-.031.039-.06.076-.092.113-.062.074-.124.149-.191.22-.048.054-.1.107-.149.16s-.1.1-.155.155c-.03.029-.061.059-.093.087-.076.073-.154.143-.234.211-.034.028-.067.057-.1.085a.053.053,0,0,1-.016.01,4.354,4.354,0,0,1-6.464-1.369l-.43.161Z",
    transform: "translate(11.942 5687.844)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M865.569,926.776l-.219.1-.123.059c-.031.016-.062.031-.093.048-.056.028-.11.057-.166.087a6.687,6.687,0,0,0-3.482,5.9s0,.43.009,1.13a10.38,10.38,0,0,1-.736,3.147,9.031,9.031,0,1,1,14.823-10.15,9.133,9.133,0,0,1,.907,2.426c0,.02.008.042.012.062a9.82,9.82,0,0,1-3.726-1.5l0,0-.06-.056c-.037-.034-.075-.068-.113-.1s-.071-.064-.109-.093-.068-.059-.1-.087l-.016-.011c-.071-.059-.146-.115-.219-.169,0,0,0,0,0,0s0,0,0,0a.007.007,0,0,1,0,0l0,0-.109-.079-.079-.054c-.047-.033-.095-.064-.143-.095-.112-.073-.227-.143-.343-.208-.076-.045-.155-.087-.234-.126l-.118-.059-.121-.057c-.031-.016-.064-.03-.095-.044s-.034-.014-.051-.022c-.112-.05-.224-.093-.337-.137l-.137-.05-.121-.04c-.042-.014-.084-.028-.127-.04-.084-.026-.169-.051-.255-.071-.042-.012-.084-.023-.127-.034l-.115-.026-.188-.039-.172-.031c-.073-.013-.144-.022-.217-.033l-.194-.023c-.158-.017-.318-.026-.478-.033-.07,0-.14,0-.21,0h-.04q-.1,0-.2,0l-.177.008-.179.014-.028,0c-.056,0-.112.011-.168.017l-.047.006-.151.02c-.029,0-.059.009-.088.016-.048.006-.1.016-.144.025-.067.012-.134.025-.2.04-.133.03-.267.064-.4.1l-.186.056c-.072.023-.143.047-.213.071C865.814,926.677,865.692,926.725,865.569,926.776Z",
    transform: "translate(76.938 5783.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M857.155,1091.68v0h0Z",
    transform: "translate(78.267 5630.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M857.155,1091.68v0h0Z",
    transform: "translate(78.267 5630.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M999.719,976.418a.038.038,0,0,0-.009-.005v0Z",
    transform: "translate(-50.635 5735.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1095.091,968.96a5.831,5.831,0,0,1-.056,1.825,8.121,8.121,0,0,0,4.257-2.129A8.626,8.626,0,0,1,1095.091,968.96Z",
    transform: "translate(-136.829 5742.051)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(942.354 6710.648)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M950.715,968.574a13.633,13.633,0,0,1-21.18.055,6.01,6.01,0,0,1,1.8-.526,6.877,6.877,0,0,1,4.757,1.169,11.976,11.976,0,0,0,1.553.887,12.292,12.292,0,0,0,13.07-1.584Z",
    transform: "translate(-929.535 -968.044)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M937.645,970.158a7.547,7.547,0,0,0-6,.548,13.723,13.723,0,0,1-2.107-2.077,6.01,6.01,0,0,1,1.8-.526,6.877,6.877,0,0,1,4.757,1.169A11.976,11.976,0,0,0,937.645,970.158Z",
    transform: "translate(12.819 5742.605)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNugoLogo);
export default __webpack_public_path__ + "static/media/nugo-logo.743450bf9064c695177ba9cc20c6793f.svg";
export { ForwardRef as ReactComponent };